// extracted by mini-css-extract-plugin
export default {"network":"styles_network__Dm17g","button":"styles_button__h9uuJ","menu":"styles_menu__Nqpyp","option":"styles_option__60nx8","status":"styles_status__xFSoZ"};